<template></template>
<script>
    export default {
        props: {
            eventName: {
                type: String,
                required: true
            },
            dimensions: {
                type: Object,
                required: true
            }
        },
        mounted() {
            if (typeof window.gtag !== 'undefined') {
                window.gtag('event', this.eventName, this.dimensions);
            } else {
                console.warn('gtag not loaded');
            }
        }
    }
</script>